import { z } from 'zod';
import { APP_CONSTRAINTS } from '@/lib/constants/app';

const optionalHttpUrl = (max: number) =>
  z
    .string()
    .max(max)
    .refine((v) => v === '' || /^https?:\/\/\S+\.\S+/.test(v), 'Enter a valid URL (https://...)');

export const appRokuFormSchema = z.object({
  title: z.string().min(1, 'Channel title is required').max(APP_CONSTRAINTS.ROKU_TITLE_MAX),
  adUrl: optionalHttpUrl(APP_CONSTRAINTS.LISTING_URL_MAX),
  genres: z.string().max(APP_CONSTRAINTS.ROKU_GENRES_MAX),
  appStateTypeId: z.number(),
});

export type AppRokuFormSchemaData = z.infer<typeof appRokuFormSchema>;

export const appRokuSetupFormSchema = z.object({
  title: z.string().min(1, 'Channel title is required').max(APP_CONSTRAINTS.ROKU_TITLE_MAX),
  adUrl: optionalHttpUrl(APP_CONSTRAINTS.LISTING_URL_MAX),
});

export type AppRokuSetupFormSchemaData = z.infer<typeof appRokuSetupFormSchema>;
